import React from 'react';
import AIChatMessage from "../../../../../../core/model2/ai/chat-message/chat-message";
import {RTFVersion} from "../../../../../../core/gd-components/editor/@type";
import RichTextEditorUniversal from "../../../../../../core/gd-components/editor-universal/editor-universal";

type Props = {
    message: AIChatMessage
}

export default function AIChatQueryMessage(props: Props) {

    return (
        <div className="flex-row-right-center w-100p">
            <div className="ui5-txt-default ui5-bg-highlight p-10 border-radius-6 pre-line" style={{maxWidth: 400}}>
                <RichTextEditorUniversal className      = {Classes('gd-textarea-rte')}
                                         editable       = {false}
                                         messageText    = {props.message.message}
                                         messageRTF     = {{markdown: props.message.message, v: RTFVersion.MARKDOWN}}/>
            </div>
        </div>
    );
}
